import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#3D3F44",
        "fill-rule": "evenodd",
        d: "M12 7.636A4.36 4.36 0 0 0 7.636 12 4.36 4.36 0 0 0 12 16.364 4.36 4.36 0 0 0 16.364 12 4.36 4.36 0 0 0 12 7.636m9.753 3.273a9.81 9.81 0 0 0-8.662-8.662V1.091C13.09.49 12.6 0 12 0s-1.09.49-1.09 1.09v1.157a9.81 9.81 0 0 0-8.663 8.662H1.091C.49 10.91 0 11.4 0 12s.49 1.09 1.09 1.09h1.157a9.81 9.81 0 0 0 8.662 8.663v1.156C10.91 23.51 11.4 24 12 24s1.09-.49 1.09-1.09v-1.157a9.81 9.81 0 0 0 8.663-8.662h1.156C23.51 13.09 24 12.6 24 12s-.49-1.09-1.09-1.09zM12 19.636A7.63 7.63 0 0 1 4.364 12 7.63 7.63 0 0 1 12 4.364 7.63 7.63 0 0 1 19.636 12 7.63 7.63 0 0 1 12 19.636",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }